/** @format */

import axios from 'axios';

import Notify from '../../../../components/Commons/Notify';

import { ENV_FUNCTION_CLAIM } from '../../../../components/Commons/Hooks/Variables/Enviroment';

export async function serviceGetClaim(item) {
	return await axios({
		method: 'POST',
		url: `${ENV_FUNCTION_CLAIM}/search`,
		data: item,
	})
		.then((response) => {
			if (response.data.statusCode === 200) {
				return response.data.data;
			} else if (response.data.error === 'Not Found') {
				Notify({
					title: `No se encontró solicitud`,
					description: 'No se encontró solicitud con el ID ingresado',
					colorTitle: 'ph-main-notification-warning-title',
					image: 'warning',
					placement: 'topRight',
					time: 5,
				});
				return {};
			} else {
				Notify({
					title: `Error: ${response.data.error}`,
					colorTitle: 'ph-main-notification-error-title',
					description: `Problemas con el servicio: ${response.data.message}`,
					time: 3,
					image: 'error',
					placement: 'topRight',
				});
				return {};
			}
		})
		.catch((error) => {
			console.log(error);
			// Notify({
			// 	title: 'Problemas de Conexión',
			// 	colorTitle: 'ph-main-notification-error-title',
			// 	description: 'Revisa tu conexión o ponte en contacto con nosotros',
			// 	time: 4,
			// 	image: 'error',
			// 	placement: 'topRight',
			// });
		});
}
